import _ from 'lodash';

import {
  AWAIT_REGION_CODING,
  FINISH_REGION_CODING,
  HANDLE_REGION_CODING_ERROR,
  HANDLE_CUSTOM_COLOR_PALETTE_ERROR,
  HIDE_REGION_CODING_ERROR,
  REQUEST_REGION_CODING,
  RESET_STATE,
  SET_COLOR_PALETTE_PROPERTIES,
  SET_FILTERS,
  SET_MAP_INFO_DISMISSED,
  SET_DATASET_SELECTION_MODAL_TOGGLE,
  SET_CURRENT_MAP_LAYER_MODE,
  SET_REGION_CODING_SHAPEFILE_ID,
  SET_USER_ACTIVE,
  SET_USER_IDLE,
  SET_VIF_CHECKPOINT,
  SET_VISUALIZATION_TYPE,
  TRIGGER_AUTO_SELECT_GEO_LOCATION_COLUMN,
} from '../actions';

export var defaultState = {
  selectedVisualizationType: null,
  mapInfoDismissed: false,
  showRegionCodingProcessingMessage: false,
  regionCodingError: null,
  regionCodingLastChecked: null,
  hasPannedOrZoomed: false,
  filters: [],
  userCurrentlyActive: false,
  customColorPaletteError: null,
};

export default function authoring(state, action) {
  if (_.isUndefined(state)) {
    return defaultState;
  }

  state = _.cloneDeep(state);

  if (!_.isUndefined(action.targetVisualizationType)) {
    // Modify the state only if the action is target for a specific targetVisualizationType.
    // For multi layer maps, we need to switch the dataset and domain for maps/table as
    // we switch layers. But those actions should not affect other visualizations.
    return state;
  }

  switch (action.type) {
    case RESET_STATE:
      state = defaultState;
      break;

    case SET_FILTERS:
      state.filters = _.cloneDeep(action.filters);
      break;

    case SET_VIF_CHECKPOINT:
      state.checkpointVifs = _.cloneDeep(action.vifs);
      break;

    case SET_VISUALIZATION_TYPE:
      state.selectedVisualizationType = action.visualizationType;
      state.hasPannedOrZoomed = false;
      break;

    case TRIGGER_AUTO_SELECT_GEO_LOCATION_COLUMN:
      state.triggerAutoSelectGeoLocationColumn = action.toggle;
      break;

    case SET_MAP_INFO_DISMISSED:
      state.mapInfoDismissed = true;
      break;

    case SET_DATASET_SELECTION_MODAL_TOGGLE:
      state.showDatasetSelectionModal = action.toggle;
      break;

    case SET_CURRENT_MAP_LAYER_MODE:
      state.currentMapLayerIndexView = action.currentMapLayerIndexView;
      break;

    case REQUEST_REGION_CODING:
      state.showRegionCodingProcessingMessage = true;
      state.regionCodingError = null;
      state.regionCodingLastChecked = null;
      break;

    case SET_REGION_CODING_SHAPEFILE_ID:
      state.regionCodingShapefileIdInProcess = action.shapefileId;
      break;

    case HANDLE_REGION_CODING_ERROR:
      state.showRegionCodingProcessingMessage = false;
      state.regionCodingError = action.error;
      break;

    case HIDE_REGION_CODING_ERROR:
      state.regionCodingError = null;
      break;

    case FINISH_REGION_CODING:
      state.showRegionCodingProcessingMessage = false;
      state.regionCodingError = null;
      break;

    case AWAIT_REGION_CODING:
      state.regionCodingLastChecked = action.updatedAt;
      break;

    case SET_USER_ACTIVE:
      state.userCurrentlyActive = true;
      break;

    case SET_USER_IDLE:
      state.userCurrentlyActive = false;
      break;

    case SET_COLOR_PALETTE_PROPERTIES:
      state.customColorPaletteError = null;
      break;

    case HANDLE_CUSTOM_COLOR_PALETTE_ERROR:
      state.customColorPaletteError = action.error;
      break;
  }

  return state;
}
